import type { FunctionComponent } from 'react'
import { useState } from 'react'
import { useGetPropertiesFilteredAndSorted } from '../../hooks/useGetPropertiesFilteredAndSorted'
import { useIsReservationUi } from '../../next/useIsReservationUi'
import { PropertyFilterOverviewNoResults } from './PropertyFilterOverviewNoResults'
import { PropertyFilterOverviewResultHeading } from './PropertyFilterOverviewResultHeading'
import { PropertyFilterProjectLink } from './PropertyFilterProjectLink'

export const PropertyIndexFilterResultTitle: FunctionComponent<React.PropsWithChildren<{}>> = () => {
  const [mobileFilterOpen, setMobileFilterOpen] = useState(false)
  const { allPropertiesFilteredAndSorted, loading } =
    useGetPropertiesFilteredAndSorted()
  const isReservationUi = useIsReservationUi()

  const showNoResults =
    !loading && allPropertiesFilteredAndSorted?.length === 0 && !isReservationUi

  return (
    <div className="bg-accentroAquaVeryLight-full col-span-12 pt-px-48 pb-px-128 -mx-px-24 px-px-24 space-y-px-24 md:-mx-px-32 md:px-0 md:col-span-8 md:pt-px-64 md:space-y-px-48 md:pb-[240px] lg:col-span-9 lg:mx-0 lg:pt-px-96 lg:space-y-px-64 lg:pb-[240px]">
      {!showNoResults && <PropertyFilterProjectLink />}
      <PropertyFilterOverviewResultHeading
        mobileFilterOpen={mobileFilterOpen}
        setMobileFilterOpen={setMobileFilterOpen}
        showNoResults={showNoResults}
      />
      {showNoResults && <PropertyFilterOverviewNoResults />}
    </div>
  )
}
